const FeaturesSchema = {
  title: 'Features',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'backgroundImage',
        'items'
      ],
    },
  ],
  properties: {
    backgroundImage: {
      title: 'Backround Image',
      type: 'string',
      widget: 'image',
    },
    items: {
      title: 'Items',
      widget: 'object_list',
      schema: {
        title: 'Item',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: [
              'icon', 
              'title', 
              'text'
            ],
          },
        ],
        properties: {
          icon: {
            title: 'Icon',
            type: 'string',
            description: 'Accepts any Semantic UI icon name'
          },
          title: {
            title: 'Title',
            type: 'string',
          },
          text: {
            title: 'Text',
            type: 'string',
            widget: 'textarea',
          },
        },
        required: [],
      },
    },
  },
  required: [],
};

export default FeaturesSchema;